import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=7777033c&scoped=true&"
import script from "./Announcement.vue?vue&type=script&lang=js&"
export * from "./Announcement.vue?vue&type=script&lang=js&"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=7777033c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7777033c",
  null
  
)

export default component.exports